import React from 'react'
import SingleValue from 'components/form/SingleValue'
import { Flag } from 'components/Flag'

export const CurrencySingleValue = ({ position, data: { abbreviature, name, flag, isCrypto}, ...props}) => {
	return <SingleValue className={position} {...props}>
		<Flag src={flag} alt={name} isCrypto={isCrypto} className={`u-margin-${position === 'left' ? 'right' : 'left' }-small`} />
		<span>{abbreviature}</span>
	</SingleValue>
}

export default CurrencySingleValue
